import React from 'react';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMHomeHostBannerGroupView extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="top-static__area">
        <div className="container">
          <div className="row top-category">
            <div className="col-sm-12 col-md-3">
              <div className="top-category__image">
                <a href={Routes.listing_about_index_path()}><img src={SMRailsBridge.assetPath.staticHostEntry} alt="登録／掲載するには" className="top-category__image-pict" />
                  <div className="top-category__image-bg">
                    <h3 className="top-category__title">登録／掲載<span className="top-category__title-sub-br">するには</span></h3>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="top-category__image">
                <a href={Routes.how_it_works_host_about_index_path()}><img src={SMRailsBridge.assetPath.staticHostFlowUse} alt="ご利用の流れ" className="top-category__image-pict" />
                  <div className="top-category__image-bg">
                    <h3 className="top-category__title">ご利用の<span className="top-category__title-sub-br">流れ</span></h3>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="top-category__image">
                <a href={Routes.host_trust_about_index_path()}><img src={SMRailsBridge.assetPath.staticHostSafety} alt="安心への取り組み" className="top-category__image-pict" />
                  <div className="top-category__image-bg">
                    <h3 className="top-category__title">安心への<span className="top-category__title-sub-br">取り組み</span></h3>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-3">
              <div className="top-category__image">
                <a href={Routes.hospitality_about_index_path()}><img src={SMRailsBridge.assetPath.staticHostPopular} alt="人気スペースにするには" className="top-category__image-pict" />
                  <div className="top-category__image-bg">
                    <h3 className="top-category__title">人気スペースに<span className="top-category__title-sub-br">するには</span></h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SMHomeHostBannerGroupView;


// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomeHostBannerGroupView.jsx